// src/api/http.ts

import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "https://api.flavourchaser.co";

export const http = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let refreshPromise: Promise<string | null> | null = null;

async function refreshAdminToken(): Promise<string | null> {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const res = await axios.post(
          `${API_BASE}/auth/refresh`,
          {},
          { withCredentials: true }
        );

        const token = res.data?.token;
        if (!token) return null;

        localStorage.setItem("authToken", token);

        if (res.data?.user) {
          const storeId = String(res.data.user.location_id || 1);
          localStorage.setItem("store_id", storeId);
          localStorage.setItem(
            "adminUser",
            JSON.stringify({
              name: res.data.user.name,
              email: res.data.user.email,
              store_id: storeId,
            })
          );
        }

        return token;
      } catch {
        return null;
      } finally {
        refreshPromise = null;
      }
    })();
  }

  return refreshPromise;
}

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (!originalRequest) {
      return Promise.reject(error);
    }

    const status = error?.response?.status;
    const alreadyRetried = originalRequest._retry;

    const url = originalRequest?.url || "";
const isAuthRoute =
  url.includes("/auth/login") ||
  url.includes("/auth/refresh") ||
  url.includes("/auth/logout") ||
  url.includes("/auth/validate-token");

if ((status === 401 || status === 403) && !alreadyRetried && !isAuthRoute) {
      originalRequest._retry = true;

      const nextToken = await refreshAdminToken();
      if (!nextToken) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("store_id");
        localStorage.removeItem("adminUser");
        return Promise.reject(error);
      }

      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.Authorization = `Bearer ${nextToken}`;
      return http(originalRequest);
    }

    return Promise.reject(error);
  }
);